import CalendarService from '../lib/services/CalendarService';
import { injectLogos } from '../lib/utils';

const fetchSpac = (params = {}, injectTickersLogos = true, pageSize = 1000): Promise<any> => {
  const query = {
    ...params,
    pagesize: pageSize,
    'parameters[ipo_type]': 'SPAC',
  };

  const Calendar = new CalendarService();
  return Calendar.getIPOs(query).then(({ data }: any) => {
    const items: any = [];
    if (Array.isArray(data.ipos) && data.ipos.length) {
      data.ipos = data.ipos.filter((item: any) => item.ipo_type === 'SPAC').reverse();
      return injectTickersLogos ? injectLogos(data.ipos) : data.ipos;
    }
    return items;
  });
};

export { fetchSpac };
